import * as React from "react";
import { memo } from "react";
const SvgPortingStatus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m1.4 6.55-.058.09A.75.75 0 0 0 2 7.75h3.15l-.394 3.157c-.096.763.883 1.158 1.344.543l4.5-6 .058-.09A.75.75 0 0 0 10 4.25H6.849l.395-3.157C7.34.33 6.361-.065 5.9.55l-4.5 6z", fill: "currentColor" }));
const Memo = memo(SvgPortingStatus);
export default Memo;
